<template>
  <div>
    <div class="row">
        <div class="col-sm-12">
            <div class="page-title-box">
                <div class="float-right">
                    <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="javascript:void(0);">BPD BALI</a></li>
                    <li class="breadcrumb-item active">Group</li>
                    <li class="breadcrumb-item active">{{ $route.name == 'adminGroupCreate' ? 'Tambah' : 'Edit' }}</li>
                    </ol>
                </div>
                
                <h4 class="page-title">
                    <router-link :to="{ name: 'adminGroup' }">
                        <i class="fas fa-arrow-left mr-2"></i>
                    </router-link>
                    Group
                </h4>
            </div>
        </div>
    </div>

    <div>
        <div class="card card-loader d-flex" v-if="loadingInitial">
            <div class="justify-content-center">
                <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
                <p class="mt-2">Loading</p>
            </div>
        </div>
        <form @submit.prevent="submitForm()" v-else>
             <div class="card">
                <div class="card-body">
                    <div class="form-group" :class="{ 'is-invalid': $v.dataGroup.name.$error }">
                        <label class="col-form-label text-left d-block">Nama</label>
                        <input type="text" class="form-control" placeholder="Masukkan Nama" 
                        v-model.trim="$v.dataGroup.name.$model"
                        :disabled="loading">
                        <div class="error" v-if="!$v.dataGroup.name.required">Nama wajib diisi</div>
                    </div>

                    <div class="row align-items-center mb-3" v-if="$route.name == 'adminGroupCreate'">
                        <div class="col-12 col-md-4 col-lg-2">
                            <img :src="logoImage == null ? require('@/assets/custom-images/placeholder-image.png') : logoImage" alt="" style="width: 100%">
                        </div>
                        <div class="col-12 col-md-8 col-lg-10">
                            <label class="form-label">Logo</label>
                            <div class="form-group custom-file" :class="{ 'is-invalid': $v.dataGroup.logo.$error }">
                                <label class="col-form-label text-left d-block">Logo</label>
                                <input type="file" class="custom-file-input mb-3" id="upload-logo" :disabled="loading" @change="logoUpload" style="display: none" accept="image/png, image/jpg, image/jpeg">
                                <label class="custom-file-label" for="upload-logo">{{labelLogo}}</label>
                                <div class="error mt-2" style="margin-bottom: 15px" v-if="!$v.dataGroup.logo.required">Logo wajib diisi</div>
                            </div>
                        </div>
                    </div>

                    <div class="row align-items-center mb-3" v-else>
                        <div class="col-12 col-md-4 col-lg-2">
                            <img :src="logoImage == null ? require('@/assets/custom-images/placeholder-image.png') : logoImage" alt="" style="width: 100%">
                        </div>
                        <div class="col-12 col-md-8 col-lg-10">
                            <label class="form-label">Logo</label>
                            <div class="form-group custom-file">
                                <label class="col-form-label text-left d-block">Logo</label>
                                <input type="file" class="custom-file-input mb-3" id="upload-logo" :disabled="loading" @change="logoUpload" style="display: none" accept="image/png, image/jpg, image/jpeg">
                                <label class="custom-file-label" for="upload-logo">{{labelLogo}}</label>
                            </div>
                        </div>
                    </div>


                    <div class="form-group">
                        <label class="form-label">Pilih Instansi</label>
                        <select class="form-control select-2-form" id="select-2-form" :disabled="loading"
                            v-select2
                            multiple="multiple"
                            v-model="dataGroup.company_ids">
                            <!-- <option value="" selected disabled>--- Pilih Instansi ----</option> -->
                            <option :value="item.id" :data-name="item.name" v-for="item in dataInstance"
                                :key="item.id">
                                {{item.name}}</option>
                        </select>
                    </div>
                </div>
            </div>


            <button class="btn btn-success waves-effect waves-light mb-5" :disabled="loading">
                Simpan Group
                <div class="spinner-border text-light ml-2" role="status" v-if="loading">
                    <span class="sr-only">Loading...</span>
                </div>
            </button>

            <br>
        </form>
    </div>

  </div>
</template>

<script>
    import Swal from 'sweetalert2'
    import { required, sameAs, minLength, helpers } from 'vuelidate/lib/validators'
    const username = helpers.regex('username', /^[a-z0-9_]*$/)

    export default {
        data() {
            return {
                loadingInitial: true,
                labelLogo: 'Pilih File ...',
                loading: false,
                logoImage: null,
                dataInstance: [],
                dataGroup: {
                    name: '',
                    logo: null,
                    company_ids: []
                },
            };
        },
        validations() {
            if(this.$route.name == 'adminGroupCreate'){
                return {
                    dataGroup: {
                        name: {
                            required
                        },
                        logo: {
                            required
                        }
                    }
                }
            }else{
                return {
                    dataGroup: {
                        name: {
                            required
                        }
                    }
                }
            }
        },
        methods: {
            logoUpload(e) {
                const file = e.target.files[0]

                if(this.validationImage(file)){ 
                    document.getElementById('upload-logo').value = ""
                    this.labelLogo = 'Pilih File ...'
                    return
                }

                this.logoImage = URL.createObjectURL(file);
                this.dataGroup.logo = file
                this.labelLogo = file.name
            },
            // SUBMIT FORM
            submitForm() {
                // IF VALIDATION INVALID
                if (this.$v.dataGroup.$invalid) {
                    this.$v.$touch()
                    this.sAlert('error', 'Harap isi semua form dengan benar!')
                    return
                }

                this.loading = true

                let url, method, alertSuccess
                let dataStored = new FormData()

                if(this.$route.name == 'adminGroupCreate') {
                    url = `group/store`
                    method = 'POST'

                    dataStored.append('name', this.dataGroup.name)
                    dataStored.append('logo', this.dataGroup.logo)
                    this.dataGroup.company_ids.forEach(element => {
                        dataStored.append('company_ids[]', element)
                    });

                    alertSuccess = 'Berhasil membuat group baru!'
                }else{
                    url = `group/update/${this.$route.params.id}`
                    method = 'POST',
                    alertSuccess = 'Berhasil mengupdate group!'

                    dataStored.append('name', this.dataGroup.name)
                    if(this.dataInstance.logo){
                        dataStored.append('logo', this.dataGroup.logo)
                    }
                    this.dataGroup.company_ids.forEach(element => {
                        dataStored.append('company_ids[]', element)
                    });
                    dataStored.append('_method', 'PUT')
                }

                this.$http({
                    method,
                    url: `${this.API_URL}${url}`,
                    data: dataStored,
                    headers: { 'Authorization': `Bearer ${this.$cookies.get("token_admin")}` }
                })
                .then(response => {
                    const result = response.data;
                    if(result.success) {
                        this.sAlert('success', alertSuccess)
                        this.$router.push({ name: 'adminGroup' });
                    }else {
                        this.sAlert('error', result.message)
                    }
                    
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    this.sAlert('error', "Error, Terjadi Kesalahan!")
                    this.sAlert('error', error.response.data.message)
                });
            }
        },
        async mounted() {
            this.loadingInitial = true

            // LOAD DATA INSTANCE
            try {
                const instance = await this.$http.get(`${this.API_URL}company`, {
                    headers: { 'Authorization': `Bearer ${this.$cookies.get("token_admin")}` }
                })
                this.dataInstance = instance.data.data
                setTimeout(() => {
                    $('.select-2-form').select2();
                }, 100);
            } catch (error) {
                this.errorHandler(error)
            }

            // LOAD DATA IF ROUTE IS EDIT
            if(this.$route.name == 'adminGroupEdit'){
                this.loadingInitial = true
                // LOAD DATA
                this.$http.get(`${this.API_URL}group/${this.$route.params.id}`, {
                    headers: { 'Authorization': `Bearer ${this.$cookies.get("token_admin")}` }
                })
                .then(response => {
                    this.loadingInitial = false

                    const result = response.data;
                    
                    if(result.success) {
                        this.dataGroup.name = result.data.name
                        this.dataGroup.company_ids = result.data.company_ids
                        this.logoImage = result.data.logo
                        setTimeout(() => {
                            $('.select-2-form').select2();
                        }, 100);
                    }else {
                        this.sAlert('error', result.message)
                    }

                    this.loading = false;
                })
                .catch(error => {
                    this.loadingInitial = false;
                    this.sAlert('error', "Error, Terjadi Kesalahan!")
                });
            }

            this.loadingInitial = false
        }
    }
</script>